__turbopack_context__.v({
  "section": "YnLdxa_section",
  "subtitle": "YnLdxa_subtitle",
  "title": "YnLdxa_title",
});
